import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { currentUserCanAccess } from 'utils/roles';
import SettingsShell from 'screens/Settings/components/wrappers/SettingsShell';
import BillingAndPlansForm from 'screens/Settings/screens/personal/BillingAndPlans/BillingAndPlans.form';
import { Message } from 'semantic';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEnabledPaymentMethods } from 'contexts/enabledPaymentMethods';
import { useUser } from 'contexts/user';
import BillingAndPlansFormV2 from './BillingAndPlansV2.form';
import { BillingPlanForm } from 'components/forms/BillingPlanForm/BillingPlanForm';

// Note: This account billing page is for personal/individual accounts and is different (in the business context) from organization account billing.
// This page needs to exist separately in the settings sidebar under the "account" menu for individual accounts.
export default function BillingAndPlansContainer() {
  //TODO: Add error boundary layer
  const { t } = useTranslation();
  const cannotReadBillingInformation = !currentUserCanAccess(
    'accounts-billing',
    'read'
  );

  const queryClient = useMemo(() => {
    return new QueryClient();
  }, []);
  useEffect(() => () => queryClient.clear(), []);

  if (cannotReadBillingInformation) {
    return (
      <>
        <Message warning>
          {t(
            'access.cannotViewBillingInformation',
            'You do not have sufficient permissions to view billing information.'
          )}
        </Message>
      </>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsShell>
        <BillingPlanFormWrapper />
      </SettingsShell>
    </QueryClientProvider>
  );
}

function BillingPlanFormWrapper() {
  const { provider } = useUser();
  const { enabledPaymentMethods } = useEnabledPaymentMethods();

  if (provider?.enablePSPIntegrationsV2 && enabledPaymentMethods.length > 0) {
    return <BillingAndPlansFormV2 />;
  } else {
    return <BillingAndPlansForm />;
  }
}
